const apiPaths = {
  currentUser: '/current_user',
  deleteBinSummary: '/deleted_files/count',

  resetConnectionToken: '/users/:userId/connection_token/reset'
};

const storeApiPaths = {
  userStoreInfo: '/shared-header',
  registrations: '/registrations'
}

const authApiPaths = {
  impersonations: '/impersonations'
};

export function useSessionApi() {
  const userId = useSessionStore().currentUserId;

  return {
    async signUp({ name, email, password, referralSource = 'default', recaptchaToken }) {
      const source = `webapp_${referralSource}`;
      const data = await useStoreApi().post(
        storeApiPaths.registrations,
        {
          body: {
            user: {
              name,
              email,
              password,
              tos_agreed: true
            },
            source,
            recaptcha: recaptchaToken
          }
        }
      );
      return data.user;
    },

    async getCurrentUser() {
      const data = await useMarsApiV3().fetch(apiPaths.currentUser);
      return data.user;
    },

    async getUserStoreInfo() {
      return await useStoreApi().fetch(storeApiPaths.userStoreInfo);
    },

    async getDeleteBinSummary() {
      return await useMarsApiV3().fetch(apiPaths.deleteBinSummary);
    },

    async updateCurrentUser(user) {
      const data = await useMarsApiV3().put(
        apiPaths.currentUser,
        {
          body: {user}
        }
      );

      return data.user;
    },

    async startImpersonate({id}) {
      return useAuthApi().post(
        authApiPaths.impersonations,
        {
          body: {
            impersonating: id,
            client_id: useEnvConfig({
              sandbox:    'authClientIdSandbox',
              staging:    'authClientIdStaging',
              production: 'authClientIdProduction',
            }) || useRuntimeConfig().public.authClientId
          }
        }
      );
    },

    async stopImpersonate() {
      return useAuthApi().delete(
        authApiPaths.impersonations,
        {
          params: {
            query: {
              client_id: useEnvConfig({
                sandbox:    'authClientIdSandbox',
                staging:    'authClientIdStaging',
                production: 'authClientIdProduction',
              }) || useRuntimeConfig().public.authClientId
            }
          }
        }
      );
    },

    async resetConnectionToken() {
      return await useMarsApiV3().fetch(
        apiPaths.resetConnectionToken,
        {
          method: 'POST',
          params: {
            route: {userId}
          }
        }
      );
    }

  };
}
